import {createRoot} from 'react-dom/client';

import App from '@/root/App';

import '@/shared/styles/idcard-bridge.css';
import '@/shared/styles/idcard-issue-m.css';
import '@/shared/styles/custom.css';

function bootApp() {
  const app = document.getElementById('app');
  if (app) {
    const root = createRoot(app);
    root.render(<App />);
  }
}

bootApp();
